import { TApplicationState } from '../../types/redux';
import { pathOr } from 'ramda';
import { IHouse } from '../../types/newbuilding/house';

export const getEscrowHouses = (state: TApplicationState) => {
  const houses = pathOr([], ['newbuilding', 'housesByName'], state) as IHouse[];

  return houses.filter(house => house.isEscrow);
};
